import { createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../../api";
import { IAddCampaignData } from './types';

export const addCampaign = createAsyncThunk('campaign/addCampaign', async (data: IAddCampaignData, { rejectWithValue }) => {
  try {
    const response= await api.post('/campaigns/create', data);
    return response.data;
  }
  catch (error: any) {
    return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
  }
});

export const updateCampaign = createAsyncThunk('campaign/updateCampaign', async ({ id, data }: { id: number; data: IAddCampaignData }, { rejectWithValue }) => {
  try {
    const response = await api.patch(`/campaigns/${id}`, data);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
  }
});

export const deleteCampaign = createAsyncThunk('campaign/deleteCampaign', async (id: number, { rejectWithValue }) => {
  try {
    const response = await api.delete(`/campaigns/${id}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
  }
});

export const fetchCampaigns = createAsyncThunk('campaign/fetchCampaigns', async ( params: { tab: string, page?: number, limit: number}, { rejectWithValue }) => {
  try {
    const response= await api.get('/campaigns', { params });
    return response.data;
  }
  catch (error: any) {
    return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
  }
});

export const fetchInactiveInvitee = createAsyncThunk(
  'campaign/fetchInactiveInvitee',
  async (params: { page?: number; limit: number; name?: string }, { rejectWithValue }) => {
    try {
      const response = await api.get('api/referral/inactive-invitee', { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
    }
  }
);

export const fetchInactiveCatchUsers = createAsyncThunk(
  'campaign/fetchInactiveCatchUsers',
  async (params: { page?: number; limit: number; name?: string }, { rejectWithValue }) => {
    try {
      const response = await api.get('api/user-catch/inactive', { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
    }
  }
);

export const sendManualNotification = createAsyncThunk(
  'campaign/sendManualNotification',
  async (data: { user_id: number; tab: string }, { rejectWithValue }) => {
    try {
      const response = await api.post('campaigns/trigger', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || { message: 'An unexpected error occurred' });
    }
  }
);